export default "__VITE_ASSET__DU2ef3rF__"